import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import DetailUserComponent from '../../../components/Admin/users/DetailUserComponent';

const DetailUserPage = () => {
    const params = useParams();
    const navigate = useNavigate();

    let redirect = () => {
        navigate('/');
    }

    return <DetailUserComponent
        userId={ params.userId }
        redirectUserHome={ () => redirect() }
    />;
}

export default DetailUserPage;